export default
{
    name: 'app-page-slider'
}



// WEBPACK FOOTER //
// ./src/components/app-page-slider/script.js